import "./style.css";
import React, { useEffect, useState } from "react";
import StyledForm from "../../assets/StyledForm";
import lock from "../../../images/auth/lock.svg";
import { useSelector } from "react-redux";
import en from "../../../util/locales/en";
import ar from "../../../util/locales/ar";
import { useForm } from "react-hook-form";
import { forget_password } from "../../../hooks/Auth/forget-password/authFunctions";
import ksa from "../../../images/flags/ksa.png";

const Recover = ({ onSubmit, formData, setFormData, isDisabled }) => {
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm();

  const [loginLoading, setLoginLoading] = useState(false);

  const recoverSubmit = handleSubmit(async (data) => {
    const { mobile } = data;
    const formattedData = {
      phonenumber: `+966${mobile}`,
    };
    console.log("Final Login Data : ", formattedData);

    setLoginLoading(true);

    try {
      const response = await forget_password(formattedData);

      if (response?.status === 200) {
        onSubmit();
        localStorage.setItem("phone_number", formattedData.phonenumber);
      }
    } catch (err) {
      console.error("Error during login:", err);
    } finally {
      setLoginLoading(false);
    }
  });

  return (
    <div className="container">
      <img src={lock} className="section-icon" alt="img" />
      <div className="title">
        <p>{t.authPages.forget_password_page.recovery.title_line1}</p>
        <p>{t.authPages.forget_password_page.recovery.title_line2}</p>
      </div>
      <div className="text desktop-only">
        {t.authPages.forget_password_page.recovery.text}
      </div>
      <StyledForm
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="fields">
          <div className="input-div" key="mobile">
            <div className="mobile-input-div">
              <div
                className="phone-input-container"
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  className="country-code-prefix"
                  style={{
                    position: "absolute",
                    left: language === "ar" ? "auto" : "12px",
                    right: language === "ar" ? "12px" : "auto",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#333",
                    fontSize: "16px",
                    fontWeight: "500",
                    zIndex: 1,
                    pointerEvents: "none",
                  }}
                >
                  <img src={ksa} alt="ksa" style={{ width: "20px" }} /> +966
                </span>
                <input
                  name="mobile"
                  placeholder={t.authPages.mobile}
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  required={true}
                  maxLength={9}
                  onKeyDown={(e) => {
                    if (["e", "-", "+", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  {...register("mobile", {
                    required: {
                      value: true,
                      message: "required",
                    },
                    pattern: {
                      value: /^\d{9}$/,
                      message: "invalidLength",
                    },
                    onChange: (e) => {
                      const value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 9);
                      setFormData({
                        ...formData,
                        mobile: value,
                      });
                    },
                  })}
                  style={{
                    paddingLeft: language === "ar" ? "12px" : "90px",
                    paddingRight: language === "ar" ? "90px" : "12px",
                    width: "100%",
                  }}
                  value={formData["mobile"] || ""}
                />
              </div>
            </div>
            {errors["mobile"]?.message && (
              <p className="error-text">
                {errors["mobile"].message === "invalidLength"
                  ? language === "en"
                    ? `${t.authPages.mobile} must be 9 digits`
                    : `${t.authPages.mobile} يجب أن يكون 9 أرقام`
                  : language == "en"
                  ? `${t.authPages.mobile} is ${t[errors["mobile"]?.message]}`
                  : `${t[errors["mobile"]?.message]} ${t.authPages.mobile}`}
              </p>
            )}
          </div>
        </div>

        <div className="btn-container">
          <button
            className="submit"
            type="submit"
            onClick={recoverSubmit}
            disabled={loginLoading}
          >
            {t.authPages.forget_password_page.recovery.recover}
          </button>
        </div>
      </StyledForm>
    </div>
  );
};

export default Recover;
